export const FETCH_UTILISATEURS_REQUEST = 'FETCH_UTILISATEURS_REQUEST';
export const FETCH_UTILISATEURS_SUCCESS = 'FETCH_UTILISATEURS_SUCCESS';
export const FETCH_UTILISATEURS_FAILURE = 'FETCH_UTILISATEURS_FAILURE';
export const CREATE_UTILISATEUR_REQUEST = 'CREATE_UTILISATEUR_REQUEST';
export const CREATE_UTILISATEUR_SUCCESS = 'CREATE_UTILISATEUR_SUCCESS';
export const CREATE_UTILISATEUR_FAILURE = 'CREATE_UTILISATEUR_FAILURE';
export const UPDATE_UTILISATEUR_REQUEST = 'UPDATE_UTILISATEUR_REQUEST';
export const UPDATE_UTILISATEUR_SUCCESS = 'UPDATE_UTILISATEUR_SUCCESS';
export const UPDATE_UTILISATEUR_FAILURE = 'UPDATE_UTILISATEUR_FAILURE';
export const DELETE_UTILISATEUR_REQUEST = 'DELETE_UTILISATEUR_REQUEST';
export const DELETE_UTILISATEUR_SUCCESS = 'DELETE_UTILISATEUR_SUCCESS';
export const DELETE_UTILISATEUR_FAILURE = 'DELETE_UTILISATEUR_FAILURE';

export const fetchUtilisateurs = () => ({ type: FETCH_UTILISATEURS_REQUEST });
export const createUtilisateur = (data) => ({ type: CREATE_UTILISATEUR_REQUEST, payload: data });
export const updateUtilisateur = (id, data) => ({ type: UPDATE_UTILISATEUR_REQUEST, payload: { id, data } });
export const deleteUtilisateur = (id) => ({ type: DELETE_UTILISATEUR_REQUEST, payload: id });
